import { getDataFromServer } from "../util";

//Pegar o valor atual de cada moeda
export const getPrice = () => getDataFromServer("GET", "/price/me", null, true);
